import { useEffect } from "react";
import { resolveCustomerLoyaltyBalance } from "../lib/loyalty-balance";
import {
  clearCustomerDisplayCustomer,
  setCustomerDisplayCustomer,
} from "../lib/customer-display-customer";
import type { PaymentDialogCustomerSelection } from "../ui/PaymentDialog";

function formatCustomerDisplayName(
  customer: PaymentDialogCustomerSelection,
): string {
  const name = [customer.firstName, customer.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return name || customer.phone?.trim() || "ສະມາຊິກ";
}

export function useSyncCustomerDisplayCustomer(input: {
  enabled: boolean;
  branchId: string | null;
  customer: PaymentDialogCustomerSelection | null;
  clearWhenDisabled?: boolean;
}) {
  const { enabled, branchId, customer, clearWhenDisabled = false } = input;

  const customerKey = customer
    ? [
        customer.id ?? "",
        customer.localCustomerId ?? "",
        customer.phone ?? "",
        customer.firstName ?? "",
        customer.lastName ?? "",
      ].join("|")
    : "";

  useEffect(() => {
    if (!enabled) {
      if (clearWhenDisabled) clearCustomerDisplayCustomer();
      return;
    }
    if (!branchId || !customer) {
      clearCustomerDisplayCustomer();
      return;
    }

    let cancelled = false;
    const displayName = formatCustomerDisplayName(customer);

    setCustomerDisplayCustomer({
      displayName,
      loyaltyPointsBalance: null,
    });

    void (async () => {
      const balance = await resolveCustomerLoyaltyBalance({
        branchId,
        customerId: customer.id,
        customerSnapshot: customer.customerSnapshot,
        phone: customer.phone ?? undefined,
        firstName: customer.firstName,
        lastName: customer.lastName,
      });
      if (cancelled) return;
      setCustomerDisplayCustomer({
        displayName,
        loyaltyPointsBalance: balance,
      });
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled, branchId, customerKey, clearWhenDisabled]);
}
